var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcommerceDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 3.5H5.58313C4.43813 3.5 3.5 4.4375 3.5 5.58313V12.875C3.5 14.0212 4.4375 14.9581 5.58313 14.9581H12.875C14.0206 14.9581 14.9581 14.0206 14.9581 12.875V5.58313C14.9581 4.4375 14.0206 3.5 12.875 3.5ZM12.875 12.875H5.58313V5.58313H12.875V12.875ZM12.875 17.0419H5.58313C4.43813 17.0419 3.5 17.9794 3.5 19.125V26.4169C3.5 27.5619 4.43813 28.5 5.58313 28.5H12.875C14.0206 28.5 14.9581 27.5619 14.9581 26.4169V19.125C14.9581 17.9794 14.0206 17.0419 12.875 17.0419ZM12.875 26.4169H5.58313V19.125H12.875V26.4169ZM17.0419 3.5H22.25V5.58313H17.0419V3.5ZM17.0419 11.8331H24.3337V13.9169H17.0419V11.8331ZM17.0419 7.66687H28.5V9.75H17.0419V7.66687ZM17.0419 17.0419H28.5V19.125H17.0419V17.0419ZM17.0419 25.375H24.3337V27.4581H17.0419V25.375ZM17.0419 21.2081H22.25V23.2913H17.0419V21.2081Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerceDevelopment);
export default __webpack_public_path__ + "static/media/Ecommerce Development.67b2285be85268880f9d7279e1179824.svg";
export { ForwardRef as ReactComponent };